import type { ReactElement } from 'react'
import cc from 'classcat'

import { ResultsList, SearchField, SuggestedSearch } from '../../templateComponents/SuggestedSearch'
import Link from '../../templateComponents/Link'

export default function Search({ t, searchData }: SearchThemeComponentProps): ReactElement {
  return (
    <section className="search">
      <h1>
        {searchData.queryString
          ? t('components.productSearchComponent.resultsCard.resultsState.title', {
              queryString: searchData.queryString,
            })
          : t('components.productSearchComponent.resultsCard.noQueryState.title')}
      </h1>

      {searchData.products.length > 0 && searchData.queryString && (
        <ul>
          {searchData.products.map((product) => (
            <li key={product.href} className="search-result">
              <Link to={product.href}>{product.name}</Link>
            </li>
          ))}
        </ul>
      )}

      {(searchData.products.length === 0 || !searchData.queryString) && (
        <div>
          <div className="search-no-result-form">
            <h2 className="search-no-result-form-headline">
              {t('components.productSearchComponent.resultsCard.noResultsState.title')}
            </h2>
            <SuggestedSearch namespace="content">
              <div className="search-form">
                <SearchField
                  maxSuggestedItems={5}
                  placeholder={t('components.productSearchComponent.searchInputField.placeholder')}
                />
                <ResultsList
                  renderItems={(items) => (
                    <ul>
                      {items.map((item) => (
                        <li className={cc({ active: item.active })} key={item.productId}>
                          <Link to={item.href}>{item.name}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                />
              </div>
            </SuggestedSearch>
          </div>

          <div className="search-no-result-hint">
            <h3>{t('components.productSearchComponent.resultsCard.noResultsState.hintSection.title')}</h3>
            <ul>
              <li>{t('components.productSearchComponent.resultsCard.noResultsState.hintSection.proposalOne')}</li>
              <li>{t('components.productSearchComponent.resultsCard.noResultsState.hintSection.proposalTwo')}</li>
            </ul>
          </div>
        </div>
      )}
    </section>
  )
}
